export default __webpack_public_path__ + "static/media/renewal-available_loan-mobile.4d31296f.jpg";